/**
 * WebSocket Feature - Main Exports
 */

// Core Hooks
export { useWebSocketManager } from './useWebSocketManager';

// SOC2 ticket-based secure socket helpers
export {
  mintWsTicket,
  connectSecureWs,
  buildSecureWsUrl,
  getWsBaseUrl,
  normalizeWsBase,
  isPrivateChannel,
  handleWsTicketUnauthorized,
  WsTicketError,
} from './secureSocket';
export type {
  WsChannel,
  MintWsTicketResult,
  MintWsTicketOptions,
  ConnectSecureWsOptions,
} from './secureSocket';

// Real-time Domain Hooks
export {
  useClientRealtime,
  useRealtimeOrders,
  useRealtimeRiskAlerts,
  useRealtimeNotifications,
  useRealtimeArbitrage,
  useRealtimeAITrading,
} from './hooks';

// Real-time Types
export type {
  ClientRealtimeStatus,
  UseClientRealtimeConfig,
  UseClientRealtimeReturn,
  RealtimeOrder,
  RealtimeFill,
  RealtimeExecution,
  OrderUpdateEvent,
  UseRealtimeOrdersConfig,
  RealtimeRiskAlert,
  RealtimeRiskMetric,
  RealtimeViolation,
  UseRealtimeRiskAlertsConfig,
  RealtimeNotification,
  SystemStatus,
  NotificationType,
  NotificationPriority,
  UseRealtimeNotificationsConfig,
  RealtimeArbitrageOpportunity,
  RealtimeArbitrageExecution,
  ExchangeLatency,
  UseRealtimeArbitrageConfig,
  RealtimeAISignal,
  RealtimeAgentStatus,
  RealtimeAIPerformance,
  UseRealtimeAITradingConfig,
} from './hooks';

// Components
export { WebSocketMonitor } from './WebSocketMonitor';
